<div class="admin-container">
  <div class="card border-0 p-3">
    <app-grid-table
      [data]="database"
      [columns]="columns"
      [title]="
        'admin.sideNav.databaseManagement.projectClassification' | translate
      "
    >
      <app-add-action-button actions (add)="addElement()"
    /></app-grid-table>
  </div>
</div>
